import React from 'react'
import './Herocrm.css'
import herocrm from "../Images/herocrm.png"
import imgcrm from "../Images/crmimgnew.png"
const Herocrm = () => {
    return (
        <div id='herocrm'>
            <div className="section">
                <div className="container containercrm">
                    <div className="crmherocontent">
                        <h1 className="heroHeading">
                            <span>Custom CRM</span> Development Company
                        </h1>
                        <h4 className='heroh4'>
                          Get Any CRM Functionality For Smarter Customer Management 
                        </h4>
                        <p className='subHeading'>
                       BastionEx  CRM development services empower businesses to automate workflows, boost productivity, and deliver exceptional customer experiences. We build scalable, user-friendly CRM solutions tailored to your growth goals. 
                        </p>
                    </div>
                    {/* <img src={herocrm} alt="" className='crmheroimg' /> */}
                     <img src={imgcrm} alt="" className='img-crm' />
                </div>
            </div>
        </div>
    )
}

export default Herocrm